import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form1099Virginia = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-File West Virginia 1099 Forms | Fast & Affordable Filing"
          description="E-file your West Virginia 1099 forms effortlessly with TaxZerone. Stay compliant, avoid penalties, and file for just $0.99 per form—secure & stress-free!"
          keywords=" "
          canonical="form-1099-state-filing/west-virginia-filing-requirements/"
          jsonLdPricing="0.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-wv-landing-img.webp" />
                <source srcSet="/assets/images/1099-wv-landing-img.png" />
                <img
                  src="/assets/images/1099-wv-landing-img.png"
                  alt="Quick & Secure 1099 Filing for West Virginia"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Quick & Secure 1099 Filing for{' '}
                <span className="highlight-container">
                  <span className="highlight">West Virginia </span>
                </span>{' '}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 0,
                }}
              >
                TaxZerone makes 1099 filing for 2025 quick and effortless,
                ensuring you stay fully compliant with West Virginia’s tax
                laws—file in minutes and focus on what matters most!
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099wv`}
                  >
                    Start Filing Now!{' '}
                    {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box> */}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-wv-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099-wv-landing-img-sm.png" />
                <img
                  src="/assets/images/1099-wv-landing-img-sm.png"
                  alt="Quick & Secure 1099 Filing for West Virginia"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                E-File your West Virginia 1099 forms for only{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 22 },
                  }}
                >
                  $0.99 per form
                </Box>{' '}
                —easy, clear, and cost-effective!
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              {/* <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography> */}
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid container spacing={2} sx={{ pt: 2, pb: 2 }}>
          <Grid size={12} sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { md: 3, sm: 1, xs: 0 },
                pt: { md: 0, sm: 3 },
                textAlign: { md: 'center', sm: 'center' },
              }}
            >
              West Virginia 1099 Filing Requirements
            </Typography>
            <Typography
              variant="body1"
              id="nec"
              sx={{ mb: { md: 3, sm: 3, xs: 16 } }}
            >
              Stay compliant with West Virginia&apos;s 1099 filing requirements
              by understanding the required forms, reporting thresholds,{' '}
              <Hidden smDown>
                <br />
              </Hidden>
              submission methods, and deadlines. Ensure accurate and timely
              filing for:
            </Typography>
            <Hidden smDown>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  maxWidth: '100%',
                  alignSelf: 'center',
                  m: 0,
                }}
              >
                <Link href="#nec" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-NEC
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#misc" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-MISC
                    </Typography>
                  </Paper>
                </Link>
                {/* <Link href="#1099b" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-B
                    </Typography>
                  </Paper>
                </Link> */}
                <Link href="#div" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-DIV
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099g" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-G
                    </Typography>
                  </Paper>
                </Link>
                <Hidden mdDown>
                  <Link href="#int" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-INT
                      </Typography>
                    </Paper>
                  </Link>
                  {/* <Link href="#1099k" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-K
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#oid" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-OID
                      </Typography>
                    </Paper>
                  </Link> */}
                  <Link href="#1099r" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-R
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#w2g" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        W-2G
                      </Typography>
                    </Paper>
                  </Link>
                </Hidden>
              </Stack>
            </Hidden>
            <Hidden mdUp smDown>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  maxWidth: '100%',
                  mt: 2,
                }}
              >
                <Link href="#int" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-INT
                    </Typography>
                  </Paper>
                </Link>
                {/* <Link href="#1099k" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-K
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#oid" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-OID
                    </Typography>
                  </Paper>
                </Link> */}
                <Link href="#1099r" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-R
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#w2g" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      W-2G
                    </Typography>
                  </Paper>
                </Link>
              </Stack>
            </Hidden>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                    loading="lazy"
                    alt="West Virginia"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-NEC
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f3ff',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            rowSpan={4}
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            No Filing Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form WV/IT-103
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="misc"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mt: { xs: 6, sm: 0 },
              mb: 4,
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                    loading="lazy"
                    alt="West Virginia"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-MISC
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            rowSpan={4}
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            No Filing Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form WV/IT-103
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="div"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                    loading="lazy"
                    alt="West Virginia"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-DIV
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            rowSpan={4}
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            No Filing Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form WV/IT-103
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099g"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                    loading="lazy"
                    alt="West Virginia"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-G
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            rowSpan={4}
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            No Filing Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form WV/IT-103
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="int"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                    loading="lazy"
                    alt="West Virginia"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-INT
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            rowSpan={4}
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            No Filing Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form WV/IT-103
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099r"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                    loading="lazy"
                    alt="West Virginia"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-R
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            rowSpan={4}
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            No Filing Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form WV/IT-103
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="w2g"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                    loading="lazy"
                    alt="West Virginia"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  W-2G
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            West Virginia State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            rowSpan={4}
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            No Filing Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form WV/IT-103
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Due Date
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={12} sx={{ textAlign: 'center' }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 600,

                mb: 2,
                lineHeight: 1.5,
              }}
            >
              Get started with 1099 E-filing in West Virginia today!
            </Typography>
            <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
              <Button
                variant="contained"
                className="btn-primary"
                sx={{
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099wv`}
              >
                Start Filing Now!{' '}
                {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box> */}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{ pt: 5, pb: 5 }}
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: { md: 'left', xs: 'center' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
                {' '}
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: { md: 3, sm: 1, xs: 0 },
                    pt: { md: 0, sm: 3 },
                    textAlign: { md: 'left', sm: 'center' },
                  }}
                >
                  Who needs to File 1099 Forms in West Virginia?
                </Typography>
                <Typography variant="body1">
                  Businesses operating in West Virginia that withhold state
                  income tax must file 1099 forms for the 2025 tax year. This
                  requirement applies to all businesses, from small startups to
                  large corporations. Accurate and timely filing ensures
                  compliance with West Virginia state regulations and helps
                  avoid potential penalties.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ textAlign: 'center' }}>
              <Box>
                <picture>
                  <source srcSet="/assets/images/wv-who-need-file-img.webp" />
                  <source srcSet="/assets/images/wv-who-need-file-img.png" />
                  <img
                    src="/assets/images/wv-who-need-file-img.png"
                    alt="Who needs to File 1099 Forms in West Virginia?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={400}
                    height={400}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Why Choose TaxZerone for West Virginia 1099 Filing?
          </Typography>
          <Typography
            variant="body1"
            sx={{ px: { md: 14, sm: 3, xs: 2 }, textAlign: 'center', mb: 3 }}
          >
            Simplify your West Virginia 1099 filing process with TaxZerone. Our
            easy-to-use platform ensures a smooth and efficient experience,
            guaranteeing accurate and on-time submissions.
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Fast and Easy Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Fast and Easy Filing
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Finish your 1099 submissions in less than 5 minutes with our
                  simple 3-step process.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderColor: '#76ce97',
                  borderWidth: 3,
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Budget-Friendly Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Budget-Friendly Filing
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Submit your 1099 state forms at just <b>$0.99</b> each, with
                  no extra costs.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Streamlined Bulk Upload"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Streamlined Bulk Upload
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Quickly upload multiple forms at once to save time.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Dedicated Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Dedicated Support
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Our support team is here to assist with any questions or
                  challenges if you encounter.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Streamline your West Virginia 1099 filing with TaxZerone!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Choose our platform for effortless submissions, supporting both
          Electronic (Direct) Filing{' '}
          <Hidden smDown>
            <br />
          </Hidden>
          and the Combined Federal/State Filing (CF/SF) program to ensure your
          forms are{' '}
          <Hidden smDown>
            <br />
          </Hidden>
          submitted accurately and promptly.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099wv`}
          >
            Get Started Today
          </Button>
        </Box>
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What forms are required to file with West Virginia state?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      For West Virginia state tax filing, businesses are
                      required to submit the following 1099 forms:
                    </Typography>
                    <Box component="ul" sx={{ mb: 1, '& li': { mb: 0.6 } }}>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-nec/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-NEC
                        </Link>{' '}
                        – Nonemployee Compensation
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-misc/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-MISC
                        </Link>{' '}
                        – Miscellaneous Information
                      </li>

                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-div/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-DIV
                        </Link>{' '}
                        – Dividends and Distributions
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-g/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-G
                        </Link>{' '}
                        – Certain Government Payments
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-int/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-INT
                        </Link>{' '}
                        – Interest Income
                      </li>

                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-r/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-R
                        </Link>{' '}
                        – Distributions from Pensions, Annuities, etc.
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-w-2g/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form W-2G
                        </Link>{' '}
                        – Certain Gambling Winnings
                      </li>
                    </Box>
                    <Typography variant="body1">
                      These forms are required for compliance with West Virginia
                      state tax regulations.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Is form WV/IT-103 required for West Virginia state filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Yes, Form WV/IT-103 is required for West Virginia state
                      filing if your business withholds West Virginia income tax
                      from wages, pensions, or other payments. This form, known
                      as the Employer’s Annual Reconciliation of West Virginia
                      Withholding, is used to reconcile the total tax withheld
                      during the year.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who is required to file 1099 forms with West Virginia?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Businesses that withhold West Virginia state income tax
                      from payments to individuals or entities must file the
                      relevant 1099 forms with the West Virginia Department of
                      Revenue.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What are the deadlines for 1099 forms of West Virginia?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      The due date for filing the 1099 Form in West Virginia is
                      <span style={{ fontWeight: 600 }}> January 31</span>. If
                      this date falls on a weekend or federal holiday, the
                      deadline will be the next business day.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. What happens if I miss the deadline for West Virginia 1099
                  filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      If you miss the deadline for filing 1099 forms in West
                      Virginia, you may face penalties based on the delay and
                      the nature of the violation:
                    </Typography>
                    <Box component="div" sx={{ mb: 2 }}>
                      <TableContainer
                        sx={{ border: '1px solid #828282', borderRadius: 2 }}
                      >
                        <Table sx={{}} aria-label="Due Date Chart">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#ccc' }}>
                              <TableCell
                                sx={{
                                  color: '#444',
                                  fontWeight: 600,
                                  width: 300,
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                }}
                              >
                                Violation
                              </TableCell>

                              <TableCell
                                sx={{
                                  color: '#444',
                                  fontWeight: 600,
                                  width: 300,
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                }}
                              >
                                Penalty Rate
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: '#444',
                                  fontWeight: 600,
                                  width: 300,
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                }}
                              >
                                Maximum Penalty
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: '#444',
                                  fontWeight: 600,
                                  width: 300,
                                  textAlign: 'center',
                                  borderBottom: '1px solid #828282',
                                }}
                              >
                                Basis for Penalty
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                  fontWeight: 600,
                                }}
                              >
                                Failure to file a return on time
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                5% per month
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                25% of tax due (as shown or adjusted)
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Tax due (as shown or adjusted by Tax Division)
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                  fontWeight: 600,
                                }}
                              >
                                Failure to pay tax due on time
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                0.5% per month
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                25% of tax due (as shown or adjusted)
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Tax due (as shown or adjusted by Tax Division)
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                  fontWeight: 600,
                                }}
                              >
                                Failure to pay tax due due to negligence or
                                intentional disregard of rules
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                5% per month
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                25% of deficiency amount
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Amount of deficiency
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                  fontWeight: 600,
                                }}
                              >
                                Filing a false or fraudulent return
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                50%
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                N/A
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Amount of deficiency
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                  fontWeight: 600,
                                }}
                              >
                                Failure to pay estimated tax
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Interest rate
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                  borderRight: '1px solid #828282',
                                }}
                              >
                                N/A
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Amount of underpayment
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. Where to mail you West Virginia 1099 and W-2 forms?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      The mailing address for submitting 1099 forms to the West
                      Virginia Tax Division is:
                    </Typography>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, mb: 0.8 }}
                      >
                        {' '}
                        <MailOutlineOutlinedIcon
                          sx={{
                            position: 'relative',
                            ml: 0,
                            mr: 0.5,
                            mb: -1,
                            fontSize: 28,
                          }}
                        />{' '}
                        Mailing Address:
                      </Typography>
                      <Box
                        component="div"
                        sx={{ textAlign: 'left', fontSize: '15px important' }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: 'italic' }}
                        >
                          <span style={{ fontWeight: 600 }}>
                            West Virginia Tax Division
                          </span>
                          <br />
                          TAA/Withholding
                          <br />
                          PO Box 3943
                          <br />
                          Charleston, WV 25339-3943
                        </Typography>
                      </Box>
                    </Box>
                    <Alert severity="warning" icon={false} sx={{ mt: 2 }}>
                      <b>Note:</b> The IRS recommends e-filing for a fast,
                      secure and more convenient experience.
                    </Alert>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1099Virginia;
